module.exports = __webpack_public_path__ + "static/img/kjdh.7c8cb372.svg";